import DataDeviceType from '../const/DataDeviceType';

const MeasurementType = {
  AD: { key: 'ad', label: 'common.SENSORIC_CALCULATION' },
  BASICS: { key: 'basics', label: 'common.SENSORIC_CALCULATION' },
  WR: { key: 'wr', label: 'common.INVERTER' },
  INVERTER: { key: 'inverter', label: 'common.INVERTER' },
  GAK: { key: 'gak', label: 'common.STRING_COMBINER' },
  MET: { key: 'met', label: 'common.METER' },
  METER: { key: 'meter', label: 'common.METER' },
  BAT: { key: 'bat', label: 'common.BATTERY' },
  BATTERY: { key: 'battery', label: 'common.BATTERY' },
  METEO: { key: 'meteo', label: 'common.METEO' },
  GENSET: { key: 'genset', label: 'common.GENSET' },
  PPC: { key: DataDeviceType.PPC, label: 'common.PPC' },
  TRACKER: { key: 'tracker', label: 'common.TRACKER' },
  PCU: { key: 'pcu', label: 'common.PCU' },
  POWERMANAGEMENT: { key: 'powermanagement', label: 'common.POWERMANAGEMENT' },
  STATUS: { key: 'status', label: 'common.STATUS' },
};
export default MeasurementType;
